import { observable } from "mobx";

import { client } from "../api";
import { ApiConnector } from "../api/api-connector";
import { Patient } from "../features/patient/patient";

export class DataAdd<TPatient extends Patient | null = Patient> {
  @observable accessor initFields: string[] = [];
  @observable accessor addingList: any = [];
  @observable accessor desc = "";
  @observable accessor bodyField = "";
  @observable accessor endpoint = "";
  @observable accessor defaultDateTime: string | null = "";
  @observable accessor defaultDateTimeName = "";
  @observable accessor defaultDateTimeFields: string[] = [];
  @observable accessor customDateTime = "";
  @observable accessor reloadToTab = "";
  @observable accessor requiredFields: string[] = [];

  @observable accessor requiredEitherOr: string[] = [];
  @observable accessor required: string[] = [];

  constructor(
    public api: ApiConnector,
    public patient: TPatient,
  ) {}

  async initEmpty() {}

  removeItem(index: number) {
    this.addingList.splice(index, 1);
  }

  addItem() {
    this.addingList.push({});
  }

  setAllDatetimes(datetime: string) {
    for (const field of this.addingList) {
      for (const key of this.defaultDateTimeFields) {
        field[key] = datetime;
      }
    }
    if (datetime === this.defaultDateTime) {
      this.customDateTime = "";
    } else {
      this.customDateTime = datetime;
    }
  }

  customSanitize(field: object) {
    return field;
  }

  async postBulk(): Promise<boolean> {
    // filter by required
    const filteredData =
      this.requiredFields.length === 0
        ? this.addingList
        : this.addingList.filter((item: any) =>
            this.requiredFields.every(
              (field) => item[field] != null && item[field] !== "",
            ),
          );
    for (let i = 0; i < filteredData.length; i++) {
      if (this.patient) {
        filteredData[i].patient_id = this.patient.patientId;
      }
      filteredData[i] = this.customSanitize(filteredData[i]);
    }

    const body: Record<string, unknown> = {};
    body["number_of_datapoints"] = filteredData.length;
    body[this.bodyField] = filteredData;

    const response = await client.post({
      url: `/api/${this.api.apiVersion}/${this.endpoint}`,
      body,
    });

    if (response.data != null) {
      this.api.clearResponseCache();
      return true;
    }
    return false;
  }
}
